/**
 * @generated SignedSource<<e8b5681ab2d6e4c9175bc0c05ea6c0fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PrintAreaTemplateCreateInput = {
  height: number;
  name: string;
  width: number;
};
export type printAreaEditorDialogMutation$variables = {
  input: PrintAreaTemplateCreateInput;
};
export type printAreaEditorDialogMutation$data = {
  readonly createPrintAreaTemplate: {
    readonly printAreaTemplate: {
      readonly height: number;
      readonly name: string;
      readonly templateID: number;
      readonly width: number;
    } | null;
  } | null;
};
export type printAreaEditorDialogMutation = {
  response: printAreaEditorDialogMutation$data;
  variables: printAreaEditorDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printAreaEditorDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PrintAreaTemplateOutput",
        "kind": "LinkedField",
        "name": "createPrintAreaTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintAreaTemplate",
            "kind": "LinkedField",
            "name": "printAreaTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "printAreaEditorDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PrintAreaTemplateOutput",
        "kind": "LinkedField",
        "name": "createPrintAreaTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintAreaTemplate",
            "kind": "LinkedField",
            "name": "printAreaTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7c6b51201b6b0310eef3eb0bce557f14",
    "id": null,
    "metadata": {},
    "name": "printAreaEditorDialogMutation",
    "operationKind": "mutation",
    "text": "mutation printAreaEditorDialogMutation(\n  $input: PrintAreaTemplateCreateInput!\n) {\n  createPrintAreaTemplate(input: $input) {\n    printAreaTemplate {\n      templateID\n      name\n      width\n      height\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc74a71a80c4e603ed11ab4a34ecbc14";

export default node;
